import { RECALCULATE_ITINERARY, RESET_ITINERARY } from "./displayItineraryReducer"

export const recalculateItinerary = () => ({
    type: RECALCULATE_ITINERARY,
})

export const resetItinerary = () => ({
    type: RESET_ITINERARY,
})